import { render, staticRenderFns } from "./ViewMessage.vue?vue&type=template&id=2073970c&scoped=true&"
import script from "./ViewMessage.vue?vue&type=script&lang=js&"
export * from "./ViewMessage.vue?vue&type=script&lang=js&"
import style0 from "./ViewMessage.vue?vue&type=style&index=0&id=2073970c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2073970c",
  null
  
)

export default component.exports